import React, { useEffect, useState } from 'react'
import { API_BASE_URL } from '../../config/api'
import axios from 'axios'
import { Pie } from 'react-chartjs-2'
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  ChartOptions
} from 'chart.js'
import { PaymentDistributionData } from 'shared'

// Register Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend)

const PaymentDistributionChart: React.FC = () => {
  const [data, setData] = useState<PaymentDistributionData | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    try {
      const currentYear = new Date().getFullYear()
      const response = await axios.get(`${API_BASE_URL}/api/analytics/payment-distribution?year=${currentYear}`)
      setData(response.data.data)
    } catch (error) {
      console.error('Error fetching payment distribution data:', error)
    } finally {
      setLoading(false)
    }
  }

  if (loading || !data || data.labels.length === 0) {
    return (
      <div className="flex flex-col justify-center items-center h-64">
        {loading ? (
          <i className="pi pi-spin pi-spinner text-4xl text-gray-400"></i>
        ) : (
          <div className="text-center">
            <i className="pi pi-chart-pie text-6xl text-gray-300 mb-2"></i>
            <p className="text-gray-500">No payment data available</p>
          </div>
        )}
      </div>
    )
  }

  const chartData = {
    labels: data.labels,
    datasets: [{
      label: 'Amount (€)',
      data: data.datasets.amounts,
      backgroundColor: [
        'rgba(59, 130, 246, 0.8)',
        'rgba(34, 197, 94, 0.8)',
        'rgba(251, 191, 36, 0.8)',
        'rgba(168, 85, 247, 0.8)',
        'rgba(239, 68, 68, 0.8)'
      ],
      borderColor: [
        'rgb(59, 130, 246)',
        'rgb(34, 197, 94)',
        'rgb(251, 191, 36)',
        'rgb(168, 85, 247)',
        'rgb(239, 68, 68)'
      ],
      borderWidth: 1
    }]
  }

  const options: ChartOptions<'pie'> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'right' as const
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            const label = context.label || ''
            const value = context.parsed || 0
            const count = data.datasets.counts[context.dataIndex]
            return `${label}: €${value.toFixed(2)} (${count} payments)`
          }
        }
      }
    }
  }

  return (
    <div className="h-64">
      <Pie data={chartData} options={options} />
    </div>
  )
}

export default PaymentDistributionChart
